import React, { FC, useEffect, useState } from 'react';
import { EventBus } from '@vtblife/event-bus';
import { OpenChatEventType, OpenChatPayload, CloseChatEventType, CloseChatPayload } from '@vtblife/event-bus-events';
import { observer } from 'mobx-react';

import cn from 'classnames';

import styles from './chat-app.module.css';
import { SuspenseMicroApp, SuspenseMicroAppProps } from '../micro-app/suspense-micro-app';
import { CHAT_APP_NAME } from '../../constants';

export const ChatApp: FC<SuspenseMicroAppProps> = observer((props) => {
    const [chatId, setChatId] = useState<string | null>(null);
    useEffect(() => {
        const eventBus = (window.eventBus = EventBus.getInstance());
        const subscriptions = [
            eventBus.subscribe<OpenChatEventType, OpenChatPayload>('chat:open', ({ data }) => {
                setChatId(data.chatId ?? null);
            }),
            eventBus.subscribe<CloseChatEventType, CloseChatPayload>('chat:close', () => {
                setChatId(null);
            }),
        ];

        return () => {
            subscriptions.forEach((subscription) => subscription.unsubscribe());
        };
    }, []);

    return (
        <div className={cn({ [styles.hidden]: props.layoutStore.shouldHideChatsButtonOnMobile })}>
            <SuspenseMicroApp
                {...props}
                appName={CHAT_APP_NAME}
                chatId={chatId === 'chat-list' ? null : chatId}
                initialPage={chatId && chatId !== 'chat-list' ? 'concrete-chat' : 'chat-list'}
                isButtonApp
                withOwnSidebar
            />
        </div>
    );
});
